import { apiWithToken } from '../api';

const resouceUrl = '/tipo_licenca';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const select = async () => {

  return await api.get(`${resouceUrl}?fields=id,nome&raw_list`);
};

export const show = async (id, params) => {
  return await api.get(`${resouceUrl}/${id}`, {
    params: {
      ...params
    },
  });
}

export const update = async (id, tipo_licenca) => {
  return await api.put(`${resouceUrl}/${id}`, tipo_licenca);
}


export const store = async (tipo_licenca) => {
  let response = await api.post(resouceUrl , tipo_licenca);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}

export const activate = async (id) => {
  return await api.post(`${resouceUrl}/${id}/activate`);
}
